import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { SyncCryptService } from '../../core/crypt/sync-crypt.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { LoggerService } from '../../core/logger.service';
import { ErrCode } from '../../shared/models';
@Component({
    selector: 'sync-dialog-link-zip',
    templateUrl: './dialog-link-zip.component.html'
})
export class DialogLinkZipComponent implements OnInit, OnDestroy {

    @Input() linkID: string;
    @Input() linkpassword: string;

    public spinner: boolean;
    public errcode: ErrCode;

    public dlReady: boolean;
    public itemsize: number;
    public zipName: string;
    public zipUrl: string;

    public errorreport: string;

    private jobSub: Subscription;
    private sub: Subscription;
    private sharekey: string;
    private pid: number;

    constructor(
        public activeModal: NgbActiveModal,
        private api: ApiService,
        private crypt: SyncCryptService,
        private log: LoggerService,
        private store: Store<fromRoot.State>
    ) { }

    ngOnInit() {
        this.spinner = true;
        this.dlReady = false;

        this.sub = this.store.select(fromRoot.getLinkFileListState)
        .pipe(first())
        .subscribe((data) => {
            if (data.cwd) {
                this.pid = data.cwd.sync_id;
            }
            const files = data.pathlist.filter((val) => {
                return (val.sync_id && val.share_key);
            });
            // console.log('files = ' , files);
            this.sharekey = data.cwd.share_key;
            this.createZip(files);
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.jobSub) {
            this.jobSub.unsubscribe();
        }
    }

    private async createZip(files: sync.IFile[]) {

        const itemlist: number[] = [];
        const cachekeylist: string[] = [];
        // console.log('looping to create items ' , files.length);
        for (let i = 0, len = files.length; i < len; i++) {
            itemlist.push(files[i].sync_id);
            if (files[i].cachekey != null) {
                cachekeylist.push(files[i].cachekey + files[i].sync_id);
            } else {
                cachekeylist.push(files[i].sync_id.toString());
            }
        }
        // console.log('cachekeylist ' , cachekeylist);
        // console.log('sync id list ' , itemlist);
        const jobId = this.crypt.getRandomHex(32);
        try {
            await this.api.execute('setjob', {
                publink_id: this.linkID,
                sync_id_list: itemlist,
                pid: this.pid,
                job_name: 'zipreport.Zipreport',
                share_key: this.sharekey,
                job_id: jobId,
                password: this.linkpassword,
                cachekeylist: cachekeylist
            });

            this.jobSub = this.api.subscribeJob(jobId).subscribe((data) => {
                if (data['status'] && data['status'] == 'error') {
                    if (data['downloading'].length) {
                        // @see error-messages.model.ts for error code meanings.
                        this.log.error('ZIP error ' + data['downloading'][0]);
                        const errormsg = data['downloading'][0];
                        const regex = /\((\d+)\)/;
                        const found = errormsg.match(regex);
                        if (found != null && found.length == 2) {
                            this.log.error('Error code from zip = ' + found[1]);
                            this.errcode = new ErrCode(parseInt('15' + found[1], 10));
                        } else {
                            this.errcode = new ErrCode(7500);
                        }
                    }
                    this.log.e('Error received in link job subscription', this.errcode);
                    this.spinner = false;
                } else if (data['status'] == 'success') {
                    if (data['totalsize'] > 0) {
                        this.itemsize = data['totalsize'];
                        this.zipName = data['zipname'] + '.zip';
                        this.zipUrl = [
                            data['url'],
                            '&pid=', data['jsonname'],
                            '&jid=', jobId
                        ].join('');
                        this.dlReady = true;
                        this.spinner = false;
                        this.log.info('Zip is ready to download');
                        this.log.info(JSON.stringify(data));
                        this.api.send('linkconsume', {
                            links: [ { publink_id: this.linkID }]
                        });
                        // a.href = this.zipurl + '&pid=' + this.jsonname + '&jid=' + this.job_id;

                        // this.itemsize = response['totalsize'];
                        // this.zipreport = response;
                        // this.spinner = false;
                        // this.zipcomplete = 1;
                        // this.zipurl = response["url"];
                        // this.message = "Ready to Download " + this.humanFileSize(this.itemsize)
                        // this.zipname = response["zipname"];
                        // this.taskname = response["taskname"];
                        // this.jsonname = response["jsonname"];
                    } else {
                        this.spinner = false;
                        this.errcode = new ErrCode(7501);
                        this.log.e('Total size of zip job was ' + data['totalsize'] , this.errcode);
                        this.log.error(JSON.stringify(data));
                    }

                } else if (data['status'] == 'fail') {
                    this.spinner = false;
                    this.errcode = new ErrCode(7502);
                    this.log.e('Server error: not enough space', this.errcode);
                } else {
                    this.spinner = false;
                    this.errcode = new ErrCode(7503);
                    this.log.e('Server error:  Unknown status code', this.errcode);
                }
            });

        } catch (ex) {
            this.errcode = ErrCode.fromException(ex);
            this.log.e('Error occurred zipping file', this.errcode);
        }

    }
}
